<template>
  <section id="news" class="news">
    <div class="container">
      <header class="section-head">
        <h2 class="section-title">最新动态</h2>
        <p class="section-lead">
          打造图书馆线上线下融合模式，推动智慧化、数字化服务升级
        </p>
      </header>
      <ul class="news-list">
        <li v-for="(item, index) in items" :key="index" class="news-item">
          <router-link
            :to="{ name: 'news-detail', params: { id: String(item.id) } }"
            class="news-link"
          >
            <time class="news-date" :datetime="item.iso">{{ item.date }}</time>
            <div class="news-cover-wrap">
              <img
                v-if="item.image"
                class="news-cover"
                :src="item.image"
                :alt="item.title"
                :loading="index < 4 ? 'eager' : 'lazy'"
                decoding="async"
              >
              <span v-else class="news-cover-ph" aria-hidden="true">NEWS</span>
            </div>
            <div class="news-body">
              <h3 class="news-title">{{ item.title }}</h3>
              <p class="news-excerpt">{{ item.excerpt }}</p>
            </div>
          </router-link>
        </li>
      </ul>
      <p class="section-cta">
        <router-link to="/news" class="link-more">进入新闻中心 →</router-link>
      </p>
    </div>
  </section>
</template>

<script>
import { fetchNewsList } from '../api/news'

export default {
  name: 'NewsSection',
  props: {
    prefetchItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      items: []
    }
  },
  async mounted() {
    const list =
      Array.isArray(this.prefetchItems) && this.prefetchItems.length
        ? this.prefetchItems
        : await fetchNewsList()
    const rows = Array.isArray(list) ? list : []
    this.items = rows.map((item) => {
      const d = item.date || ''
      return {
        id: item.id,
        iso: d,
        date: d,
        title: item.title || '资讯',
        excerpt: item.subtitle || item.intro || '',
        image: item.image || ''
      }
    })
  }
}
</script>

<style scoped>
.news {
  padding: 100px 0;
  background: #fff;
}

.section-head {
  text-align: center;
  margin-bottom: 48px;
}

.section-title {
  font-size: 42px;
  margin-bottom: 16px;
  color: #0c4a6e;
  font-weight: 700;
}

.section-lead {
  font-size: 17px;
  color: #64748b;
  max-width: 640px;
  margin: 0 auto;
  line-height: 1.75;
}

.news-list {
  list-style: none;
  margin: 0 auto;
  padding: 0;
  max-width: 900px;
}

.news-item {
  padding: 28px 0;
  border-bottom: 1px solid #e2e8f0;
}

.news-item:first-child {
  border-top: 1px solid #e2e8f0;
}

.news-date {
  font-size: 14px;
  color: #0284c7;
  font-weight: 600;
}

.news-link {
  display: grid;
  grid-template-columns: 96px 190px 1fr;
  gap: 24px;
  align-items: center;
  color: inherit;
}

.news-cover-wrap {
  width: 190px;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  background: #e2e8f0;
}

.news-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.news-cover-ph {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  letter-spacing: 0.12em;
  font-weight: 700;
  color: #0c4a6e;
  background: linear-gradient(135deg, #bfdbfe 0%, #7dd3fc 100%);
}

.news-title {
  font-size: 18px;
  color: #0c4a6e;
  font-weight: 600;
  margin: 0 0 10px;
  line-height: 1.4;
}

.news-excerpt {
  font-size: 15px;
  color: #64748b;
  line-height: 1.7;
  margin: 0;
}

.section-cta {
  text-align: center;
  margin-top: 34px;
}

.link-more {
  color: #0284c7;
  font-weight: 600;
  font-size: 16px;
}

.link-more:hover {
  color: #0369a1;
}

@media (max-width: 600px) {
  .news-item {
    padding: 22px 0;
  }

  .news-link {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .news-cover-wrap {
    width: 100%;
    max-width: 100%;
  }

  .section-title {
    font-size: 32px;
  }
}
</style>
